import { combineReducers } from 'redux';
import { fetchAggregate } from './reducers/aggregate';
import { publicReviews } from './reducers/publicReviews';
import { postReviewVote } from './reducers/reviewVote';
import { postReviewFlag } from './reducers/reviewFlag';
import { putReview } from './reducers/putReview';
import { fetchOrder } from './reducers/fetchOrder';
import { fetchReview } from './reducers/fetchReview';

// Used by inventory pages for aggregate bar and review sections
export const externalRatingReviewsReducers = combineReducers({
  publicReviews,
  postReviewVote,
  postReviewFlag,
  fetchAggregate,
});

const reviewWizardReducers = combineReducers({
  fetchReview,
  putReview,
  fetchOrder,
});

export default function reducers() {
  return {
    ratingReviews: reviewWizardReducers,
  };
}
